import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto p-8 bg-white text-black">
      <h1 className="text-4xl font-bold text-orange-500 text-center mb-6">Privacy Policy</h1>
      <p className="text-lg mb-4">Last Updated: 07/06/2024</p>
      <p className="text-lg mb-4">
        Ligovis Technical Solutions Pvt. Ltd. ("Company", "we", "our", "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and enroll in our cybersecurity courses. Please read this Privacy Policy carefully. If you do not agree with the terms of this Privacy Policy, please do not access the site or use our services.
      </p>
      <p className="text-lg mb-4">By accessing our site and using our services, you agree to this Privacy Policy and our Terms and Conditions.</p>
      <h2 className="text-2xl font-semibold text-orange-500 mt-8 mb-4">1. Information We Collect</h2>
      <p className="text-lg mb-4">We collect personal information from students who enroll in our courses. This includes:</p>
      <ul className="list-disc list-inside text-lg mb-4">
        <li>Name</li>
        <li>Education details</li>
        <li>Phone number</li>
        <li>Email address</li>
        <li>Payment information</li>
      </ul>
      <p className="text-lg mb-4">We collect this information through our website, personally, or through cookies.</p>
      <h2 className="text-2xl font-semibold text-orange-500 mt-8 mb-4">2. Use of Your Information</h2>
      <p className="text-lg mb-4">We use the information we collect from you to:</p>
      <ul className="list-disc list-inside text-lg mb-4">
        <li>Process course enrollments</li>
        <li>Issue certificates upon course completion</li>
        <li>Manage payment details for future reference</li>
        <li>Send updates and important information related to our courses and services</li>
      </ul>
      <h2 className="text-2xl font-semibold text-orange-500 mt-8 mb-4">3. Data Protection</h2>
      <p className="text-lg mb-4">Your data is safe and secure with us. We store data only on secure, encrypted servers or secure company computers. Data is retained for a maximum of one year after course completion.</p>
      <h2 className="text-2xl font-semibold text-orange-500 mt-8 mb-4">4. User Rights</h2>
      <p className="text-lg mb-4">Users have the right to:</p>
      <ul className="list-disc list-inside text-lg mb-4">
        <li>Update their personal information</li>
        <li>Opt out of courses at their discretion</li>
      </ul>
      <h2 className="text-2xl font-semibold text-orange-500 mt-8 mb-4">5. Cookies</h2>
      <p className="text-lg mb-4">We use cookies to:</p>
      <ul className="list-disc list-inside text-lg mb-4">
        <li>Track user details</li>
        <li>Manage user sessions</li>
        <li>Improve user experience</li>
      </ul>
      <h2 className="text-2xl font-semibold text-orange-500 mt-8 mb-4">6. Data Transfer</h2>
      <p className="text-lg mb-4">No data is transferred outside of India.</p>
      <h2 className="text-2xl font-semibold text-orange-500 mt-8 mb-4">7. Updates to This Privacy Policy</h2>
      <p className="text-lg mb-4">We may update this Privacy Policy from time to time. We will notify users of any changes through our website or via email.</p>
      <h2 className="text-2xl font-semibold text-orange-500 mt-8 mb-4">8. Governing Law</h2>
      <p className="text-lg mb-4">This Privacy Policy is governed by the laws of India.</p>
      <h2 className="text-2xl font-semibold text-orange-500 mt-8 mb-4">9. Contact Us</h2>
      <p className="text-lg mb-4">If you have any questions about this Privacy Policy, please contact us at:</p>
      <p className="text-lg mb-4">
        Ligovis Technical Solutions Pvt. Ltd.<br />
        Hyderabad<br />
        <a href="mailto:learn@ligovis.com" className="text-orange-500">learn@ligovis.com</a><br />
        +917671091557
      </p>
    </div>
  );
};

export default PrivacyPolicy;

